<template>
    <div v-if="userExists">
        <div class="signin">
            <h2 class="title">Einloggen</h2>
            <form class="form" @submit.prevent="submitSignin($event)">
                <div class="input-group mb-3">
                    <div style="width: 100%;">
                        <input type="password" class="" required @blur="$options.methods.checkFormCompletition($event)"
                            :disabled="auth.authenticating">
                        <div class="error-hint">Pflichtfeld</div>
                    </div>
                </div>
                <Button type="submit" class="my-4" :disabled="auth.authenticating">
                    <span v-if="auth.authenticating">Bitte warten ...</span>
                    <span v-else>Anmelden</span>
                </Button>

                <div class="text-center">
                    <p v-if="pwResettedText" v-html="pwResettedText"></p>
                    <a href="#" @click.prevent="forgotPassword" style="color: black;" v-if="!pwResetting">Kennwort vergessen</a>
                </div>

                <div class="text-danger text-center" v-if="auth.authenticatingError">Login fehlgeschlagen. Bitte versuche es erneut.
                </div>
            </form>

        </div>
    </div>
    <div v-else>
        <div class="address">
            <h2 class="title">Adresse eingeben</h2>
            <form class="form" @submit.prevent="onSubmit">
                <label for="street" class="form-label mt-3">Adresse für Angebot / Rechnung</label>
                <div class="form-check">
                    <input v-model="same_as_jobs_address" class="form-check-input" type="checkbox"
                        id="same_as_jobs_address">
                    <label class="form-check-label" for="same_as_jobs_address">
                        Identisch mit Auftragsort
                    </label>
                </div>
                <div class="form-group d-flex">
                    <div class="form-check">
                        <input v-model="clients_type" class="form-check-input" type="radio" id="clients_type_private" value="0">
                        <label class="form-check-label" for="clients_type_private">
                            Privat
                        </label>
                        </div>
                    <div class="form-check">
                        <input v-model="clients_type" class="form-check-input" type="radio" id="clients_type_company" value="1">
                        <label class="form-check-label" for="clients_type_company">
                            Firma
                        </label>
                    </div>
                </div>
                <div class="input-group" v-if="!same_as_jobs_address">
                    <input v-model="invoice_street" type="text" class="" placeholder="Straße + Hausnummer" required>
                    <div class="form-group d-flex">
                        <input v-model="invoice_zip" type="text" class="" placeholder="PLZ" required>
                        <input v-model="invoice_city" type="text" class="" placeholder="Ort" required>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <div class="form-group d-flex">
                        <div style="width: 100%;">
                            <input
                                v-model="clients_contacts_firstname"
                                type="text"
                                class=""
                                placeholder="Vorname"
                                required
                                @blur="$options.methods.checkFormCompletition($event)"
                            >
                            <div class="error-hint">
                                Pflichtfeld
                            </div>
                        </div>
                        <div style="width: 100%;">
                            <input
                                v-model="clients_contacts_lastname"
                                type="text"
                                class=""
                                placeholder="Nachname"
                                required
                                @blur="$options.methods.checkFormCompletition($event)"
                            >
                            <div class="error-hint">
                                Pflichtfeld
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div style="width: 100%;">
                        <input v-model="clients_contacts_name" type="text" class="" placeholder="Vor- und Nachname"
                            required @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld</div>
                    </div> -->
                    <div style="width: 100%" v-if="clients_type != '0'">
                        <input v-model="clients_name" type="text" class="" required placeholder="Firmenname"
                            @blur="$options.methods.checkFormCompletition($event)">
                        <div class="error-hint">Pflichtfeld</div>
                    </div>
                </div>
                <template v-if="paymentMethods.length > 0">
                    <label for="street" class="form-label">Zahlungsart</label>
                    <div class="input-group mb-3 flex-column">
                        <div class="form-check" v-for="(payment, p) in paymentMethods" :key="p">
                            <input class="form-check-input" :value="payment.name" v-model="payment_method" type="radio"
                                name="flexRadioDefault" :id="`payment-${p}`">
                            <label class="form-check-label" :for="`payment-${p}`">
                                {{ payment.name }}
                            </label>
                        </div>
                    </div>
                </template>
                <Button type="submit" class="my-4" :disabled="fetching">
                    <span v-if="fetching">Bitte warten ...</span>
                    <span v-else>Weiter</span>
                </Button>
            </form>
        </div>
    </div>
</template>
<script>
    import {
        mapActions,
        mapGetters,
    } from 'vuex'
    import Button from '../components/ux/Button.vue';
    import router from '../router';
    export default {
        name: "Signin",
        components: { Button },
        computed: {
            ...mapGetters("orders", [
                "fetching",
                "fetchingErrorCode",
                "fetchingError", 
                "location", 
                "date", "baseData", "paymentMethods", "invoiceAddress", 
                "userExists", "auth",
                "pwResetting", "pwResetted", "pwResettedText"
            ]),
            
            // password: {
            //     get() {
            //         return '';
            //     },
            //     set(value) {
            //         this.$store.commit("orders/updatePassword", {
            //             password: value
            //         });
            //     },
            // },
            street: {
                get() {
                    return this.location.street;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        street: value
                    });
                },
            },
            zip: {
                get() {
                    return this.location.zip;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        zip: value
                    });
                },
            },
            city: {
                get() {
                    return this.location.city;
                },
                set(value) {
                    this.$store.commit("orders/updateLocation", {
                        city: value
                    });
                },
            },
            is_flexible: {
                get() {
                    return this.date.is_flexible;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        is_flexible: value
                    });
                },
            },
            same_as_jobs_address: {
                get() {
                    return this.invoiceAddress.same_as_jobs_address;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        same_as_jobs_address: value
                    });
                },
            },
            clients_type: {
                get() {
                    return this.baseData.clients_type == 'private' ? 0 : 1;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_type: value != "0" ? 'company' : 'private'
                    });
                },
            },
            invoice_street: {
                get() {
                    return this.invoiceAddress.street;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        street: value
                    });
                },
            },
            invoice_zip: {
                get() {
                    return this.invoiceAddress.zip;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        zip: value
                    });
                },
            },
            invoice_city: {
                get() {
                    return this.invoiceAddress.city;
                },
                set(value) {
                    this.$store.commit("orders/updateInvoiceAddress", {
                        city: value
                    });
                },
            },
            flexible_date: {
                get() {
                    return this.date.flexible_date;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        flexible_date: value
                    });
                },
            },
            starting_date: {
                get() {
                    return this.date.starting_date;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        starting_date: value
                    });
                },
            },
            starting_time: {
                get() {
                    return this.date.starting_time;
                },
                set(value) {
                    this.$store.commit("orders/updateDate", {
                        starting_time: value
                    });
                },
            },
            clients_name: {
                get() {
                    return this.baseData.clients_name;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_name: value
                    });
                },
            },
            // clients_contacts_name: {
            //     get() {
            //         return this.baseData.clients_contacts_name;
            //     },
            //     set(value) {
            //         this.$store.commit("orders/storeBaseData", {
            //             clients_contacts_name: value
            //         });
            //     },
            // },
            clients_contacts_firstname: {
                get() {
                    return this.baseData.clients_contacts_firstname;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_firstname: value
                    });
                },
            },
            clients_contacts_lastname: {
                get() {
                    return this.baseData.clients_contacts_lastname;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_lastname: value
                    });
                },
            },
            clients_contacts_mail: {
                get() {
                    return this.baseData.clients_contacts_mail;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_mail: value
                    });
                },
            },
            clients_contacts_mobile: {
                get() {
                    return this.baseData.clients_contacts_mobile;
                },
                set(value) {
                    this.$store.commit("orders/storeBaseData", {
                        clients_contacts_mobile: value
                    });
                },
            },
            payment_method: {
                get() {
                    const method = this.paymentMethods.filter(p => p.selected);
                    if (method.length > 0) {
                        return method[0].name;
                    }
                    return false;
                },
                set(value) {
                    this.$store.commit("orders/updatePaymentMethod", {
                        selected_payment_method: value
                    });
                },
            },
        },
        mounted() {
            this.$store.commit('orders/signInReset');
            this.checkIfUserExists();
        },
        methods: {
            ...mapActions("orders", ["checkIfUserExists", "signIn", "resetPassword"]),
            async forgotPassword() {
                this.resetPassword();
            },
            async submitSignin($e) {
                const { target } = $e;
                const pwInput = target.querySelector('input[type=password]');
                await this.signIn(pwInput.value);
                if (this.auth.authenticated) {
                    this.$options.methods.goToPath({ name: 'Summary', step: 5 });
                }
            },
            onSubmit() {
                    this.$options.methods.scrollTop();
                    router.push('Summary');
                    this.$store.dispatch("orders/navigate", 5);
            },
            setFocus(e) {
               const { target } = e;
                if (!target) {
                    return;
                }

                const hasHelperText = target.closest('.has-helper-text');
                if (!hasHelperText) {
                    return;
                }

                hasHelperText.classList.add('focus');

            }
        }
    }
</script>

<style lang="scss" scoped>
.form {
    .form-group {
    
        &.d-flex {
            column-gap: 10px;
            width: 100%;
            
            div {
                width: 100%;
            }

            div:first-of-type {
                width: 33%;
            }
        }
    }
    
    .form-label {
        margin-bottom: 14px;
    }

    .form-check-label {
        font-weight: 300;
    }

    .form-check {
        margin-bottom: 10px;
    }
    
    input:not([type="checkbox"]):not([type="radio"]) {
        margin-bottom: 10px;
    }
}

@media (min-width: 768px) {
    .signin, .address {
        padding: 30px;
        border: 1px solid $border-color;
        margin-bottom: 100px;
    }
}
</style>